import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

const styles = {
  box: {
    position: 'fixed',
    zIndex: 2000,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: 'right',
    background: 'rgba(0, 0, 0, 0.3)'
  },

  icon: {
    marginTop: '30px',
    marginRight: '30px',
    fontSize: '40px',
    color: '#fff',
    animationDuration: '900ms'
  }
};

class Loading extends React.Component {
  render() {
    const { isLoading } = this.props;

    return (
      <div style={Object.assign({}, styles.box, { display: isLoading ? 'block' : 'none' })}>
        <i className="fa fa-circle-o-notch fa-spin" style={styles.icon} />
      </div>
    );
  }
}

export default connect(
  state => ({
    isLoading: state.isLoading
  }),
  dispatch => bindActionCreators({ ...actions }, dispatch)
)(Loading);
